import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class LimitedKapAddress extends BaseMessage {
    addressLine1;
    addressLine2;
    addressLine3;
    addressLine4;
    county;
    country;
    postcode;
}
__decorate([
    Field.string({
        description: 'AddressLine1',
        maxLength: 60,
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "addressLine1", void 0);
__decorate([
    Field.string({
        description: 'AddressLine2',
        maxLength: 60,
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "addressLine2", void 0);
__decorate([
    Field.string({
        description: 'AddressLine3',
        maxLength: 60,
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "addressLine3", void 0);
__decorate([
    Field.string({
        description: 'AddressLine4',
        maxLength: 60,
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "addressLine4", void 0);
__decorate([
    Field.string({
        description: 'County',
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "county", void 0);
__decorate([
    Field.string({
        description: 'Country',
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "country", void 0);
__decorate([
    Field.string({
        description: 'PostCode',
    }),
    __metadata("design:type", String)
], LimitedKapAddress.prototype, "postcode", void 0);
//# sourceMappingURL=LimitedKapAddress.js.map